import BaseController from "confinus_ui/base_controller";

export default class SideNavbarSubItemController extends BaseController {
  public static targets = ["title"];

  declare private readonly titleTarget: HTMLHeadingElement;

  public static classes = ["shown", "filtered"];
  declare protected readonly filteredClasses: string[];
  declare protected readonly shownClasses: string[];

  public filterOnSearch(keyword: string): boolean {
    return this.toggleOnSearch(
      keyword,
      this.element,
      [this.titleTarget],
      this.shownClasses,
      this.filteredClasses,
    );
  }
}
